import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import PaymentMethod from "./../../common/PaymentMethods";

import { useUserRights } from "../../../contexts/UserRightsContext";
import AdjustmentTypes from "../../common/AdjustmentTypes";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));


const PlayerPayment = (props) => {
  const [playerPayment, setPlayerPayment] = useState({
    IdPlayer: "",
    Description: "",
    Amount: "",
    Reference: "",
    Fee: "",
    Bonus: "",
    IdPaymentMethod: "",
    TransactionType: "",
    TransactionDate: "",
    IdUser: "",
    IdAdjustmentType: "",
    PreviousBalance: "",
    NewBalance: "",
  });
  const [method, setMethod] = useState(2);
  const [adjustmentType, setAdjustmentType] = useState(1);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const [insertTran, setInsertTran] = useState(false);
  const [statistic, setStatistic] = useState();

  const [selectedTransactionType, setSelectedTransactionType] = useState("A");
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);

  const classes = useStyles();


  const setIdMethodMem = (IdMethod) => {
    setMethod(IdMethod);
  };
  const setIdPaymentOnMem = (event) => {
    setSelectedTransactionType(event.target.value);
  };
  const setIdAdjTypeMem = (adjustmentId) => {
    setAdjustmentType(adjustmentId);
  };
  const handleChangeStartDate = (event) => {
    setStartDate(event.target.value);
  };
  const GetPlayerBalance = () => {
    let url =
      process.env.REACT_APP_API2_URL +
      "/Player/Player_GetStatistics?idPlayer=" +
      props.Player.idPlayer;

    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setStatistic(response.data);
    });
  };
  useEffect(() => {
    setPlayerPayment(prev => ({
      ...prev,
      TransactionType: "A"
    }));
    GetPlayerBalance();
  }, []);

  const confirm = (e) => {
    GetPlayerBalance();
    setInsertTran(true);
  };
  const insertPayment = () => {
    const payload = {
      ...playerPayment,
      IdPlayer: props.Player.idPlayer,
      IdUser: userInfo.userId,
      IdAdjustmentType: adjustmentType,
      IdPaymentMethod: method,
      TransactionType: selectedTransactionType,
      PreviousBalance: statistic.currentBalance,
      NewBalance: CalculateNewBalance(),
      TransactionDate: startDate
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/Player_InsertTransaction",
      data: payload,
    }).then((response) => {
      props.setStatisticsToReload();
    });
    setInsertTran(false);
  };

  const CalculateNewBalance = () => {
  const balance = parseFloat(statistic?.currentBalance || 0);
  const amount = parseFloat(playerPayment.Amount || 0);
  const freePlay = parseFloat(props.Player?.freePlayAmount || 0);

  let newBalance = 0;

  if (
    selectedTransactionType === "A" ||
    selectedTransactionType === "C" ||
    selectedTransactionType === "R" ||
    selectedTransactionType === "H"
  ) {
    newBalance = balance + amount;
  } else if (selectedTransactionType === "P") {
    newBalance = freePlay + amount;
  } else {
    newBalance = balance - amount;
  }

  return newBalance || 0;
};

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const renderTransactionType = () => {
    return (
      <FormControl variant="outlined" size="small">
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          Transaction Type
        </InputLabel>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={selectedTransactionType}
          onChange={setIdPaymentOnMem}
        //   input={<BootstrapInput />}
        >
          <MenuItem value="A" hidden={!hasRights(32)}>
            Adjustment
          </MenuItem>
          <MenuItem value="C" hidden={!hasRights(43)}>
            Accrual Adjustment
          </MenuItem>
          <MenuItem value="H" hidden={!hasRights(42)}>
            Horse Adjustment
          </MenuItem>
          <MenuItem value="D" hidden={!hasRights(34)}>
            Disbursement
          </MenuItem>
          <MenuItem value="R" hidden={!hasRights(33)}>
            Receipt
          </MenuItem>
          <MenuItem value="P" hidden={!hasRights(128)}>
            Free Play
          </MenuItem>
        </Select>
      </FormControl>
    );
  };
  return (
    <div className="flex flex-col gap-4 h-max">
      <h3 style={{ textAlign: "center" }}>Payments</h3>
      <form className="w-full">
        <FormControl className="flex flex-col w-full gap-4">
          <div className="web-options">
            <div>

            </div>

            <TextField
              variant="outlined"
              type="date"
              size="small"
              defaultValue={startDate}
              onChange={handleChangeStartDate}
            />
          </div>
          <div className="web-options">
            <TextField
              size="small"
              variant="outlined"
              label="Amount"
              required
              onChange={(e) => {
                const value = e.target.value;
                setPlayerPayment(prev => ({
                  ...prev,
                  Amount: value
                }));
              }}
            />
            <PaymentMethod label="Method" setIdMethodMem={setIdMethodMem} />
          </div>
          <div className="web-options">
            <AdjustmentTypes label="Method" setIdAdjTypeMem={setIdAdjTypeMem} />
            {renderTransactionType()}{" "}
          </div>
          <div className="web-options">
            <TextField
              variant="outlined"
              size="small"
              label="Description"
              onChange={(e) => {
                const value = e.target.value;
                setPlayerPayment(prev => ({
                  ...prev,
                  Description: value
                }));
              }}
            />
            <TextField
              variant="outlined"
              size="small"
              label="Reference"
              onChange={(e) => {
                const value = e.target.value;
                setPlayerPayment(prev => ({
                  ...prev,
                  Reference: value
                }));
              }}
            />
          </div>
          <div className="web-options">
            {!insertTran ? (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  confirm();
                }}
                className="w-full"
                variant="contained"
                color="secondary"
              >
                Insert Payment
              </Button>
            ) : undefined}
            {insertTran ? (
              <div className="transaction-confirm">
                {selectedTransactionType !== "P"
                  ? <h2 className="mr-2">
                    Player Balance: {statistic?.currentBalance ?? 0}
                  </h2>
                  : <h2 className="mr-2"> Player FreePlay: {props.Player?.freePlayAmount ?? 0}</h2>
                }
                <h3 className="text-center"> Value: {playerPayment.Amount} </h3>
                <h3 className="text-center"> {selectedTransactionType !== "P" ? "New Balance:" : "New FreePlay:"} {CalculateNewBalance()}</h3>
                <Button
                  onClick={insertPayment}
                  variant="outlined"
                  color="success"
                  className="mr-1"
                >
                  Commit
                </Button>
                <Button
                  onClick={() => {
                    setInsertTran(false);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
              </div>
            ) : undefined}
          </div>
        </FormControl>
      </form>
    </div>
  );
};

export default PlayerPayment;
